var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnHook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#79D191"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8237 32.365C14.8237 32.365 27.9617 25.248 41.1043 32.365",
    stroke: "#131951",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0483 30.9504C20.0371 33.919 18.5051 37.1514 15.6315 38.1729C12.7578 39.1944 9.91668 38.3743 8.92786 35.4057C8.92786 35.4057 11.4022 33.9766 14.0902 32.6961C16.7781 31.4156 19.0483 30.9504 19.0483 30.9504V30.9504Z",
    stroke: "#131951",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8797 30.9504C35.8909 33.919 37.4229 37.1514 40.2965 38.1729C43.1701 39.1944 46.0113 38.3743 47.0001 35.4057C47.0001 35.4057 44.5257 33.9766 41.8378 32.6961C39.1498 31.4156 36.8797 30.9504 36.8797 30.9504V30.9504Z",
    stroke: "#131951",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 13C32 13 26.2667 18.6 24 21",
    stroke: "#131951",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13C24 13 29.7333 18.6 32 21",
    stroke: "#131951",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnHook);
export default __webpack_public_path__ + "static/media/on-hook.8de3982dc6afb9ffbdffea45321043ac.svg";
export { ForwardRef as ReactComponent };